(function () {
  angular
    .module('kareo.ui.shared.modules.api.provider.k-provider-type-service', [])
    .factory('kProviderTypeService', kProviderTypeService);

  kProviderTypeService.$inject = ['$http'];
  function kProviderTypeService($http) {
    const svc = {};

    svc.getProviderTypesForProviderAndTaxonomyCode = getProviderTypesForProviderAndTaxonomyCode;
    svc.getProviderTypes = getProviderTypes;
    svc.getUpdatedProviderTypes = getUpdatedProviderTypes;

    return svc;

    // ----------------------------------------------------------------------

    function getProviderTypesForProviderAndTaxonomyCode(providerGuid, taxonomyCode) {
      return $http
        .get('/admin-ui/api/Shared/providerTypes/search', {
          params: {
            providerGuid,
            taxonomyCode
          }
        })
        .then((response) => {
          return response.data;
        });
    }

    // Returns all providerTypes associated with the customer's pricing family
    function getProviderTypes() {
      return $http
        .get('/admin-ui/api/Shared/providerTypes', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }

    function getUpdatedProviderTypes(taxonomyCode, isBillingSelected) {
      return $http
        .get('/common-ui/api/User/providerTypes/taxonomyCode/' + taxonomyCode + '?billingProductActive=' + isBillingSelected)
        .then((response) => {
          return response.data;
        });
    }
  }
})();
